/**
 *  crudPageMinix.js
 *  规范教务个页面胡乱使用 avue-crud 的行为
 */

export default {

  data() {
    return {
      // 查询条件
      QUERY_CONDITIONS: {},
      // 分页
      TABLE_PAGE: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      // 排序控制
      TABLE_ORDER: [],
      // 选中列
      SELECT_LIST: [],
      // 表格loading
      TABLE_LOADING: true,
      CAS_TYPE: false

    }
  },
  methods: {
    checkInt: checkInt,
    checkDec: checkDec,
    __loadData__(TABLE_PAGE = this.TABLE_PAGE, QUERY_CONDITIONS = this.QUERY_CONDITIONS, TABLE_ORDER = this.TABLE_ORDER, done) {
      this.TABLE_LOADING = true // 表格转圈
      this.SELECT_LIST = [] // 清空选中行
      this.$http.post('url address', {}, {
        params: {

        }
      }).then(response => {

      }).catch(error => {
        this.$message.error(error.msg || error.message)
      }).finally(() => {
        this.TABLE_LOADING = false // 表格转圈
        typeof done === 'function' && done()
      })
    },
    // 导出数据
    EXPORT_EXCEL(url, fileName) {
      this.$confirm('是否确定导出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downloadFile.post(url, {
          entity: this.QUERY_CONDITIONS,
          orderItemList: this.TABLE_ORDER
        }, {
          params: {
            doDownload: true,
            fileName: fileName + '.xlsx'
          }
        }).then(res => {
          this.$message.success('正在下载...')
        }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 下载模板
    DOWNLOAD_TEMPLATE(url, fileName) {
      this.$confirm('确认下载模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downloadFile.get(url, {
          params: {
            excelTemplateType: 'save',
            fileName: fileName + '.xlsx',
            doDownload: true
          }
        }).then(res => {
          this.$message.success('正在下载!')
        }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下载'
        })
      })
    },
    // 下拉框是否有效过滤
    XLKGL(props, flag, arr) {
      arr = arr || this.option.column
      if (props && props.length > 0) {
        props.map(item => {
          let index = this.findArray(arr, item, 'prop')
          arr[index].dicData.map(i => {
            if (i.sfyx == 0) {
              i.disabled = flag
            }
          })
        })
      } else {
        arr.forEach(item => {
          item.forEach(i => {
            if (i.sfyx == 0) {
              this.$set(i, 'disabled', flag)
            }
          })
        })
      }
    },
    SEARCH_CHANGE(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      this.TABLE_PAGE.currentPage = 1
      this.QUERY_CONDITIONS = params
      this.TABLE_RELOAD(done)
    },
    // 刷新表格
    TABLE_RELOAD(done) {
      typeof this.loadData === 'function' && this.loadData(undefined, undefined, undefined, done)
    },
    // 表格刷新
    TABLE_REFRESH() {
      this.TABLE_RELOAD()
    },
    // 搜索框清空
    SEARCH_RESET() {
      this.QUERY_CONDITIONS = {}
      this.TABLE_PAGE.currentPage = 1
      this.TABLE_RELOAD()
    },
    // 当前页改变
    CURRENT_CHANGE(currentPage = 1) {
      this.TABLE_PAGE.currentPage = currentPage
      this.TABLE_RELOAD()
    },
    // 页大小改变
    SIZE_CHANGE(pageSize = 10) {
      this.TABLE_PAGE.currentPage = 1
      this.TABLE_PAGE.pageSize = pageSize
      this.TABLE_RELOAD()
    },
    // 排序改变
    SORT_CHANGE(orderInfo = {}) {
      this.TABLE_ORDER = []
      this.TABLE_PAGE.currentPage = 1
      if (orderInfo.order) {
        this.TABLE_ORDER.push({
          asc: orderInfo.order === 'ascending',
          column: orderInfo.prop
        })
      }
      this.TABLE_RELOAD()
    },
    // 行点击事件
    CELL_CLICK(row) {
      this.$refs.avueCrud && this.$refs.avueCrud.toggleRowSelection(row)
    },
    // 选中框改变
    SELECTION_CHANGE(selection = [], e) {
      this.SELECT_LIST = selection
    },
    CAS_FILTER(data, status = true) { // 级联下拉框过滤无效数据
      this.CAS_TYPE = status
      data.map(item => {
        if (item.sfyx == '0') {
          this.$set(item, 'disabled', status)
        }
      })
    },
    // 表格错位，重新渲染
    RELOAD_CRUD(data, crud = 'avueCrud', tableData = 'tableData') {
      this.$nextTick(() => {
        this[tableData] = data
        this.$refs[crud] && this.$refs[crud].doLayout()
      })
    },
    // 多选级联的搜索条件合并
    SEARCH_MERGE(params = 'params') {
      let query = JSON.parse(JSON.stringify(this.QUERY_CONDITIONS))[params]
      delete this.QUERY_CONDITIONS[params]
      Object.assign(this.QUERY_CONDITIONS, query)
    },
    // 清空表单
    RESET_FORM() {
      this.$refs.avueForm.resetForm()
    }
  }
}
export const checkInt = (rule, value, callback) => {
  let regexp = /^[1-9]\d*$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value)) || value > 100) {
      callback(new Error('请输入大于0且小于等于100的正整数'))
    }
    callback()
  }
}
export const checkDec = (rule, value, callback) => {
  let regexp = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value)) || value > 100) {
      callback(new Error('请输入大于0且小于等于100的整数或者保留一位小数'))
    }
    callback()
  }
}

export const checkNumber = (rule, value, callback) => {
  let regexp = /^[+]{0,1}(\d+)$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value))) {
      callback(new Error('请输入大于0的正整数'))
    }
    callback()
  }
}
// 验证非负整数
export const checkFFZS = (rule, value, callback) => {
  let regexp = /^100$|^(\d|[1-9]\d)$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value))) {
      callback(new Error('请输入大于等于0小于等于100的正整数'))
    }
    callback()
  }
}
// 验证考试时长小于等于240大于等于0
export const checkKSSC = (rule, value, callback) => {
  // let regexp = /(^[0-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]$)/;
  let regexp = /^\d+$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value)) || value > 240) {
      callback(new Error('请输入大于等于0且小于等于240的整数'))
    }
    callback()
  }
}
export const checkNUM = (rule, value, callback) => {
  let regexp = /^[0-9]*$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value) || value > 0)) {
      callback(new Error('请输入大于等于0的整数或者保留一位小数'))
    }
    callback()
  }
}
export const checkZXS = (rule, value, callback) => {
  let regexp = /^[1-9]\d*$/
  if (value === '') {
    callback(new Error('不可为空!'))
  } else {
    if (!(regexp.test(value)) || value > 500) {
      callback(new Error('请输入大于0且小于等于500的正整数'))
    }
    callback()
  }
}
